import { render, staticRenderFns } from "./AdminPassengerDataPreview.vue?vue&type=template&id=7763c35f&scoped=true&"
import script from "./AdminPassengerDataPreview.vue?vue&type=script&lang=js&"
export * from "./AdminPassengerDataPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7763c35f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7763c35f')) {
      api.createRecord('7763c35f', component.options)
    } else {
      api.reload('7763c35f', component.options)
    }
    module.hot.accept("./AdminPassengerDataPreview.vue?vue&type=template&id=7763c35f&scoped=true&", function () {
      api.rerender('7763c35f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Admin/AdminPassengerDataPreview.vue"
export default component.exports